export enum ApolloLoadingState {
  Loaded = 'LOADED',
  Loading = 'LOADING',
  Error = 'ERROR',
  ErrorNetwork = 'ERROR_NETWORK',
}
